import React from 'react';
import PropTypes from "prop-types";
import ErrorIcon from '@material-ui/icons/Error';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import HelpIcon from '@material-ui/icons/Help';
import {withStyles} from '@material-ui/core';
import {TooltipLeft as CustomTooltip} from "../../Common/CustomTooltips";

const useStyles = ({
    statusIcon: {
        height: 17,
        width: 17,
        margin: 3
    }
});

const evaluateStatus = (input = "", styling) => {
    switch (input) {
        case "Rozłączony+":
            return <ErrorIcon style={{ color: "red" }} className={styling} />;
        case "Rozłączony":
            return <HelpIcon style={{ color: "orange" }} className={styling} />;
        case "Podłączony":
            return <CheckCircleIcon style={{ color: "green" }} className={styling} />;
        default:
            return <ErrorIcon style={{ color: "red" }} className={styling} />;
    }
};

const convertStatusToMessage = status => {
    switch(status) {
        case "Rozłączony+":
            return "OFFLINE powyżej 24h";
        case "Rozłączony":
            return "OFFLINE poniżej 24h";
        case "Podłączony":
            return "ONLINE";
        default:
            return "BRAK DANYCH";
    }
};

const CarStatus = (props) => {
    const { classes, status } = props;

    return (
        <React.Fragment>
            <CustomTooltip title={convertStatusToMessage(status)}>
                {evaluateStatus(status, classes.statusIcon)}
            </CustomTooltip>
        </React.Fragment>
    );
};

export default withStyles(useStyles)(CarStatus);

CarStatus.propTypes = {
    classes: PropTypes.object,
    status: PropTypes.string
};
